import { Modal } from '@systemeio/ui'
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration'
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration'
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton'
import { useGoogleIntegrations } from 'modules/profile/integrations/google/hooks/use-google-integrations'
import { IntegrationUseCaseEnum } from 'modules/profile/integrations/google/types'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { GoogleMeetIcon } from '@systemeio/ui/icons'

export const GoogleMeetIntegrationComingSoon = () => {
  const { t } = useLocoTranslation()
  return (
    <WrapperIntegration
      icon={<GoogleMeetIcon />}
      title={t('dashboard.user_settings.integrations_page.google_meet.name')}
      subTitle={t('dashboard.user_settings.integrations_page.google_meet.subtitle')}
      isComingSoon
    />
  )
}

export const GoogleMeetIntegration = ({ onManageCalendar }: { onManageCalendar(): void }) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const { getIntegrationsByUseCase } = useGoogleIntegrations()

  const data = getIntegrationsByUseCase(IntegrationUseCaseEnum.Calendar)

  async function handleManageCalendar() {
    setOpened(false)
    onManageCalendar()
  }

  const isConnected = data?.items.some(integration => !integration.disconnectedAt) ?? false

  if (!data) return <WrapperIntegrationSkeleton />

  return (
    <>
      <WrapperIntegration
        icon={<GoogleMeetIcon />}
        title={t('dashboard.user_settings.integrations_page.google_meet.name')}
        subTitle={t('dashboard.user_settings.integrations_page.google_meet.subtitle')}
        onClick={() => setOpened(true)}
        isConnect={isConnected}
      />
      <Modal
        title={t('dashboard.user_settings.integrations_page.google_meet.title')}
        onClose={() => setOpened(false)}
        opened={opened}
      >
        <ConnectInfoIntegration
          handleOpenIntegrationLogin={handleManageCalendar}
          infoText={
            isConnected
              ? 'dashboard.user_settings.integrations_page.google_meet_integration.help_connected-2'
              : 'dashboard.user_settings.integrations_page.google_meet_integration.help_not_connected-2'
          }
          buttonTitle={t(
            'dashboard.user_settings.integrations_page.google_meet_integration.manage_calendar_integration',
          )}
        />
      </Modal>
    </>
  )
}
